import React from 'react';
import { useTheme } from '@components/theme';
import classNames from 'classnames';
import env from '@lib/envs/env';
import styles from './Error.module.scss';

import DefaultTemplate from '../../shared/templates/DefaultTemplate/DefaultTemplate';
import CatSvg from '../../shared/images/atoms/CatSvg/CatSvg';

export interface IErrorProps {
    message?: string;
    statusCode?: number;
}

export default function Error({ message, statusCode }:IErrorProps) {
  const theme = useTheme();
  return (
    <DefaultTemplate
      className={theme.styles.Body}
      analyticsPageProperties={{
        error_status_code: statusCode
      }}
    >
      <div className={styles.Error} data-test="o-error">
        <div className={`text-center`}>
          <CatSvg />

          <h1 className={theme.styles.Title2}>Fiddlesticks.</h1>

          <p className={styles.Blurb}>
            We can&apos;t seem to find the page you&apos;re looking for.<br />
            Let&apos;s get you back on track:
          </p>

          <div className={classNames(styles.LinkWrapper, theme.styles.Overline)}>
            <a href="/">Home</a>
            <a href={env.HELP_CENTER_URL}>Help Center</a>
            <a href="/exp/interior-design-ideas">Real Projects</a>
            <a href="/shop">Shop</a>
          </div>

          <p>{message}</p>
          <p>{statusCode}</p>
        </div>
      </div>
    </DefaultTemplate>
  );
}
